import { render, staticRenderFns } from "./cargoSvgIcon.vue?vue&type=template&id=1425a352&scoped=true&"
import script from "./cargoSvgIcon.vue?vue&type=script&lang=js&"
export * from "./cargoSvgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425a352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1425a352')) {
      api.createRecord('1425a352', component.options)
    } else {
      api.reload('1425a352', component.options)
    }
    module.hot.accept("./cargoSvgIcon.vue?vue&type=template&id=1425a352&scoped=true&", function () {
      api.rerender('1425a352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoSvgIcon.vue"
export default component.exports